import { z } from 'zod'
import { decimalSchema, uuidSchema } from './common.ts'
import { equipmentReportQuerySchema } from './equipment-report.ts'

export const productionPlanActualQuerySchema = equipmentReportQuerySchema.strict()

export const productionPlanActualRowSchema = z.object({
  stageId: uuidSchema,
  orderId: uuidSchema,
  orderNumber: z.string(),
  itemName: z.string(),
  operationName: z.string(),
  equipmentId: uuidSchema.nullable(),
  equipmentName: z.string().nullable(),
  scheduledDate: z.iso.date().nullable(),
  unitCode: z.string().nullable(),
  unitSymbol: z.string().nullable(),
  plannedQuantity: decimalSchema.nullable(),
  goodQuantity: decimalSchema,
  scrapQuantity: decimalSchema,
  variance: decimalSchema.nullable(),
})
export type ProductionPlanActualRow = z.infer<typeof productionPlanActualRowSchema>

export const productionPlanActualSchema = z.object({
  from: z.iso.date(),
  to: z.iso.date(),
  rows: z.array(productionPlanActualRowSchema),
  totals: z.array(
    z.object({
      unitCode: z.string().nullable(),
      unitSymbol: z.string().nullable(),
      plannedQuantity: decimalSchema.nullable(),
      goodQuantity: decimalSchema,
      scrapQuantity: decimalSchema,
      variance: decimalSchema.nullable(),
    }),
  ),
  unscheduled: z.int().nonnegative(),
})
export type ProductionPlanActual = z.infer<typeof productionPlanActualSchema>
